import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        style: { background: '#161b22', color: '#c9d1d9', border: '1px solid #30363d' },
        success: { iconTheme: { primary: '#f5c518', secondary: '#161b22' } },
        error: { iconTheme: { primary: '#f85149', secondary: '#161b22' } }
      }}
    />
  </React.StrictMode>
);
